import { render, staticRenderFns } from "./BtnEmitirRelatorioRequisicoes.vue?vue&type=template&id=67667325"
import script from "./BtnEmitirRelatorioRequisicoes.vue?vue&type=script&lang=js"
export * from "./BtnEmitirRelatorioRequisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports